import * as yup from 'yup';

const ItemFormValidationSchema = yup.object().shape({
  notes: yup.string().max(50, 'Item notes must be max 50 characters.'),
});

export default ItemFormValidationSchema;
